export default function updateToday (state, today) {
  state.today = today
}
